import Analytic from '@commons/cards/analytic'
import Column from '@components/column'
import Grid from '@components/grid'
import Title from '@components/title'
import React, { Fragment } from 'react'
import CategoryForm from './form'
import CategoryList from './list'
import {
  totalMatchrooms,
  totalusers,
  totalPendingOrders,
  totalStoreOrders,
  totalRevenueGenerated,
} from '@assets/icons'
import DashboardCard from '@commons/cards/dashboard'
import { cardConfig } from '../constant'

const Category = () => {
  return (
    <Fragment>
      <Column>
        <DashboardCard cardConfig={cardConfig} />
        <Title textone="Store Management >" texttwo="Category" />
        <CategoryForm />
        <CategoryList />
      </Column>
    </Fragment>
  )
}

export default Category
